import { cmsApi } from "@/api";
import { type IPlanRules } from "./types";

export const getPlanRules = async (locale: string) =>
  await cmsApi
    .get<{
      data: IPlanRules[];
    }>(`/plan-rules?locale=${locale}&pagination[limit]=1000&populate=*`)
    .then(({ data }) => data.data);
